import React, { useState } from 'react';

const PasswordInputWithToggle = ({
  id,
  name,
  value,
  onChange,
  placeholder,
  disabled,
  required,
  autoComplete,
  className,
  style,
  label = 'contraseña'
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const ariaLabel = showPassword ? `Ocultar ${label}` : `Mostrar ${label}`;

  return (
    <div style={styles.wrapper}>
      <input
        type={showPassword ? 'text' : 'password'}
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        autoComplete={autoComplete}
        className={className}
        style={{ ...(style || {}), width: '100%', paddingRight: '2.75rem' }}
      />
      <button
        type="button"
        style={{
          ...styles.toggle,
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.55 : 1
        }}
        onClick={() => setShowPassword((visible) => !visible)}
        disabled={disabled}
        aria-label={ariaLabel}
        aria-pressed={showPassword}
        title={ariaLabel}
      >
        <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`} aria-hidden="true" />
      </button>
    </div>
  );
};

const styles = {
  wrapper: {
    position: 'relative',
    width: '100%'
  },
  toggle: {
    position: 'absolute',
    right: '0.65rem',
    top: '50%',
    transform: 'translateY(-50%)',
    border: 'none',
    background: 'transparent',
    color: '#64748b',
    padding: '0.25rem',
    lineHeight: 1,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
};

export default PasswordInputWithToggle;
